import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";

const SideBarItem = ({ title, icon, active, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="rounded p-2 d-flex align-items-center my-2 side-link"
      style={{ backgroundColor: active ? "rgba(15, 188, 73, 0.1)" : "", cursor: "pointer" }}
    >
      <FontAwesomeIcon icon={icon} size="lg" color={active ? "#2E9913" : "#000"} />
      <div style={{ color: active ? "#2E9913" : "#000", marginInline: 10 }}>{title}</div>
    </div>
  );
};

export default withRouter(SideBarItem);
